import {
  ChangeEvent,
  forwardRef,
  KeyboardEvent,
  useEffect,
  useRef,
} from 'react';
import { isMobile, detectBrowser } from './../helpers';

interface InputProps {
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  errorMessage?: string;
  fontSize?: number;
  haveError?: boolean;
  maxLength?: string;
  name?: string;
  onBlur?: () => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  placeholder?: string;
  type?: string;
  unitLabel?: string;
  value?: string;
  autocomplete?: string;
}

const Input = forwardRef(
  (
    {
      className,
      defaultValue,
      disabled,
      errorMessage,
      fontSize = 17,
      haveError,
      maxLength,
      name,
      onBlur,
      onChange,
      onFocus,
      onKeyDown,
      placeholder,
      type,
      unitLabel,
      value,
      autocomplete,
    }: InputProps,
    ref: any
  ) => {
    const inputRef: any = useRef(null);

    useEffect(() => {
      if (ref) {
        ref.current = inputRef.current;
      }
    }, [inputRef.current]);

    const scrollInputIntoViewTimeout = isMobile() ? 500 : 0;

    return (
      <div
        className={`relative w-full max-w-[294px] md:max-w-[400px] md-max:max-w-[279px] short:!w-[350px] ${
          className ?? ''
        }`}>
        <input
          id={name}
          ref={inputRef}
          className={`w-full short:!w-[350px] text-[3c3c3c] placeholder:font-normal md-max:max-w-[279px] h-12 md:h-[57px] border border-[#3c3c3c] rounded-[60px] text-[${fontSize}px] short:!text-[15px] py-[18.5px] px-6 ${
            haveError ? 'border-1 border-red-600' : ''
          } disabled:bg-[#e5e4e3]`}
          defaultValue={defaultValue}
          disabled={disabled}
          maxLength={maxLength ? Number(maxLength) : undefined}
          name={name}
          onBlur={onBlur}
          onChange={(e) => onChange(e)}
          onFocus={() => {
            if (isMobile() && detectBrowser() !== 'safari') {
              setTimeout(() => {
                inputRef?.current?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                });
              }, scrollInputIntoViewTimeout);
            }
            onFocus && onFocus();
          }}
          onKeyDown={onKeyDown}
          pattern={type === 'number' ? '\\d*' : undefined}
          placeholder={placeholder}
          type={type || 'text'}
          value={value}
          autoComplete={autocomplete}
        />
        {unitLabel && (
          <p className="absolute top-[12px] md:top-[17px] short:top-[8px] right-[15px] md:right-[23px] text-[16px]">
            {unitLabel}
          </p>
        )}
        {haveError && (
          <p className="text-[12px] md:text-[14px] text-red-600 mt-2">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);

export default Input;
